module.exports = __webpack_public_path__ + "img/ico-limited.0e6fb23e.png";